<nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
        <span class="navbar-brand" routerLink="/home">The Covid-19 Tracker</span>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav">
            <li class="nav-item">
              <a class="nav-link" routerLink="/home">Home</a>
            </li>
            <li class="nav-item" *ngIf="profile=='Yes'">
              <a class="nav-link" routerLink="/dashboard">DashBoard</a>
            </li>
            <!-- <li class="nav-item" *ngIf="profile=='Yes'">
              <a class="nav-link" routerLink="/the-i-bot">The Covid Bot</a>
            </li>  -->
            <li class="nav-item" *ngIf="profile=='Yes'">
              <a class="nav-link" routerLink="/India">The InterCountry Data - India</a>
            </li>            
          </ul>
          <ul class="navbar-nav ml-auto">
            <li class="nav-item" style="color:white">
              <span *ngIf="uname!=null && profile=='Yes'">Hi, {{uname}} &nbsp;&nbsp;&nbsp;&nbsp;</span>
              <a class="btn navbar-btn btn-info" *ngIf="profile=='Yes' && uname!=null" (click)="logout()">Logout</a>
              <button class="btn navbar-btn btn-primary" *ngIf="profile=='No'" routerLink='/login'>Login</button>&nbsp;&nbsp;
              <button class="btn navbar-btn btn-primary" *ngIf="profile=='No'" routerLink='/signup'>Signup</button>
          </li>
          </ul>
        </div>
</nav>
<br>
<br>
<!-- <h3 style="text-align:center;color:white;" class="h3 bg-danger">Body Temperature: 
  {{temp}} &nbsp; &nbsp; &nbsp; &nbsp; <span *ngIf="symptomCheck==true">Symptoms: {{symptoms}}</span>
  &nbsp; &nbsp; &nbsp; &nbsp; <span *ngIf="symptomCheck==false">Symptoms: No Unusual Symptoms</span>
  &nbsp; &nbsp; &nbsp; &nbsp; <span>Already affected by COVID19?: {{covidAlreadyCame}}</span>
</h3> -->